const getExchangeRateTooltip = (fundCurrency: string, capTableCurrency: string, exchangeRate = 1): string => {
  if (fundCurrency === capTableCurrency) return '';

  return `1 ${capTableCurrency} -> ${exchangeRate} ${fundCurrency}`;
};

export default getExchangeRateTooltip;
